import React from 'react'
import { Menu } from 'antd'
import { useLocation } from 'wouter'
import {
  BarChartOutlined,
  DatabaseOutlined,
  FolderOutlined,
  LogoutOutlined,
  PlusOutlined,
  RobotOutlined,
  EuroCircleOutlined,
  SwitcherOutlined,
} from '@ant-design/icons'
import { Divider } from 'antd'
import { Affix } from 'antd'

const findCurrent = (items) => {
  const url = new URL(window.location.href)
  const path = url.pathname + url.search
  let found = ['Content', 0]
  for (let i = 0; i < items.length; i++) {
    if (path.startsWith(items[i].subpath)) {
      found[0] = items[i].name
      for (let k = 0; k < items[i].items.length; k++) {
        let curr = items[i].items[k]
        if (path.startsWith(curr.path)) {
          found[1] = k
          break
        }
      }
      break
    }
  }
  return found
}

export function MainMenu({ auth }) {
  const [, setLocation] = useLocation()

  const clickMenu = (ev) => {
    if (ev.item?.props?.href) {
      setLocation(ev.item.props.href)
    }
    if (ev.key === 'Logout') {
      return auth.logout()
    }
  }

  const menus = [
    {
      name: 'Catalogue',
      subpath: '/-admin/?',
      items: [
        { title: 'Products', path: '/-admin/?path=/bodegas/' },
        { title: 'Promos', path: '/-admin/?path=/promos/' },
        { title: 'Home', path: '/-admin/?path=/home/' },
        { title: 'Landings', path: '/-admin/?path=/landings/' },
        { title: 'Packs', path: '/-admin/?path=/packs/' },
        { title: 'Grappes & Tags', path: '/-admin/?path=/tags/' },
        { title: 'Regions', path: '/-admin/?path=/zonas/' },
        { title: 'Opinions', path: '/-admin/opinions' },
        { title: 'Offers', path: '/-admin/offers' },
        { title: 'Free Shipping Rates', path: '/-admin/promos_trg' },
        { title: 'Newsletter', path: '/-admin/?path=/newsletters/' },
        { title: 'Users', path: '/-admin/users' },
      ],
      Icon: FolderOutlined,
    },
    {
      name: 'Market Place',
      subpath: '/-admin/market-place',
      items: [
        {
          title: 'Match products',
          path: '/-admin/market-place/match-products',
        },
        { title: 'Edit matchs', path: '/-admin/market-place/edit-matchs' },
      ],
      Icon: SwitcherOutlined,
    },
    {
      name: 'Orders',
      subpath: '/-admin/orders/',
      items: [
        { title: 'Delays & Notifications', path: '/-admin/orders/delays' },
        { title: 'Group Orders', path: '/-admin/orders/preparation-group' },
        {
          title: 'Multi order invoice',
          path: '/-admin/orders/multi-order-invoice',
        },
      ],
      Icon: DatabaseOutlined,
    },
    {
      name: 'Invoices',
      subpath: '/-admin/invoices/',
      items: [
        {
          title: 'Import shipping invoices',
          path: '/-admin/invoices/import-shipping-invoices',
        },
        {
          title: 'Import commissions collections',
          path: '/-admin/invoices/import-commissions-collections-v2',
        },
        {
          title: 'Import invoice Eurotax',
          path: '/-admin/invoices/import-invoice-eurotax',
        },
        {
          title: 'Import cost warehouse',
          path: '/-admin/invoices/import-cost-warehouse',
        },
      ],
      Icon: EuroCircleOutlined,
    },
    {
      name: 'Content AI',
      subpath: '/-admin/content_ai/',
      items: [
        {
          title: 'Content generated for AI',
          path: '/-admin/content_ai/content_generated',
        },
      ],
      Icon: RobotOutlined,
    },
    {
      name: 'Create product content',
      path: '/-admin/product/create-content',
      Icon: PlusOutlined,
    },
    {
      name: 'Analytics',
      path: '/-admin/analytics',
      Icon: BarChartOutlined,
    },
    {
      name: 'Backoffice',
      path: '/administracion/',
      Icon: RobotOutlined,
    },
    {
      name: 'Logout',
      Icon: LogoutOutlined,
    },
  ]

  const [sub, key] = findCurrent(menus)

  return (
    <Affix>
      <Menu
        onClick={clickMenu}
        style={{ width: '100%' }}
        defaultSelectedKeys={[`${sub}_${key}`]}
        defaultOpenKeys={[sub]}
        mode="inline"
        className="menu-sidebar"
      >
        <a className="navbar-item" href="/">
          <img
            src={process.env.PUBLIC_URL + '/logo.svg'}
            alt="Guillotina logo"
            height="60"
            style={{ paddingLeft: '20px', marginTop: '10px' }}
          />
        </a>
        <Divider />
        {menus.map((block) => {
          if (!block.items) {
            return (
              <Menu.Item key={block.name} href={block.path || block.subpath}>
                <block.Icon />
                <span>{block.name}</span>
              </Menu.Item>
            )
          }

          return (
            <Menu.SubMenu
              key={block.name}
              title={
                <span>
                  <block.Icon /> <span>{block.name}</span>
                </span>
              }
            >
              {block.items.map((ele, idx) => (
                <Menu.Item key={block.name + '_' + idx} href={ele.path}>
                  {ele.title}
                </Menu.Item>
              ))}
            </Menu.SubMenu>
          )
        })}
      </Menu>
    </Affix>
  )
}
